import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ProjectMatchInsight } from './project-match-insights.model';

export interface GenerateProjectMatchInsightOptions {
  readonly id?: number;
  readonly projectId: number;
  readonly userId: number;
  readonly insight: string;
}

export function generateProjectMatchInsightObject({
  id = generateId(),
  projectId,
  userId,
  insight,
}: GenerateProjectMatchInsightOptions): ProjectMatchInsight {
  return {
    id,
    projectId,
    userId,
    insight,
  };
}
